import DEFAULT_BADGE_CLASS_NAME from '../../constants/badge';
import FingoMuiBadge from '../../fingo/components/MuiBadge';

const defaultBadge = ({ theme }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: theme.palette.secondary.A400,
    color: theme.palette.primary.contrastText,
  },
});

const MuiBadge = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...FingoMuiBadge.styleOverrides.root({ theme }),
      [`&.${DEFAULT_BADGE_CLASS_NAME}`]: defaultBadge({ theme }),
    }),
  },
};

export default MuiBadge;
